<template>
  <div class="contact-page-container">

    <div class="contact-banner">
      <div class="banner-content">
        <h1>联系我们</h1>
        <p>如有任何疑问或合作意向，欢迎通过以下方式联系我们</p>
      </div>
    </div>

    <div class="contact-content">
      <el-row :gutter="30">

        <el-col :xs="24" :sm="8">
          <div class="contact-card" data-aos="fade-up" data-aos-delay="100">
            <div class="icon-wrapper color-blue">
              <el-icon><PhoneFilled /></el-icon>
            </div>
            <h3>电话咨询</h3>
            <p class="desc">工作日 9:00 - 18:00</p>
            <p class="info-text">15379801925（韩老师）</p>
            <p class="info-text">19926424842（吴老师）</p>
          </div>
        </el-col>

        <el-col :xs="24" :sm="8">
          <div class="contact-card" data-aos="fade-up" data-aos-delay="200">
            <div class="icon-wrapper color-orange">
              <el-icon><Message /></el-icon>
            </div>
            <h3>发送邮件</h3>
            <p class="desc">我们会尽快回复您的邮件</p>
            <p class="info-text">gdqkch@163.com</p>
          </div>
        </el-col>

        <el-col :xs="24" :sm="8">
          <div class="contact-card" data-aos="fade-up" data-aos-delay="300">
            <div class="icon-wrapper color-green">
              <el-icon><LocationFilled /></el-icon>
            </div>
            <h3>办公地址</h3>
            <p class="desc">欢迎莅临指导</p>
            <p class="info-text">广东省深圳市光明区尚智科园1A栋5楼（光明城科学人才港）</p>
            <p class="info-text">广东省广州市广州国际生物岛寰宇一路云润大厦9楼（广东省科技社团创新基地）</p>
          </div>
        </el-col>

      </el-row>

      <div class="qr-section" data-aos="fade-up" data-aos-delay="400">
        <div class="qr-box">
          <div class="qr-image-wrapper">
            <img src="@/assets/official-account-qr.jpg" alt="公众号二维码" class="qr-img">
          </div>
          <p>关注官方公众号</p>
        </div>

        <div class="qr-box">
          <div class="qr-image-wrapper">
             <img src="@/assets/wechat-service-qr.jpg" alt="客服微信" class="qr-img">
          </div>
          <p>联系微信</p>
        </div>
      </div>

      <div class="back-home-wrapper">
        <el-button @click="$router.push('/')" plain round>返回首页</el-button>
      </div>

    </div>
  </div>
</template>

<script>
import { PhoneFilled, Message, LocationFilled } from '@element-plus/icons-vue'

export default {
  name: 'ContactView',
  components: {
    PhoneFilled,
    Message,
    LocationFilled
  }
}
</script>

<style scoped>
.contact-page-container {
  min-height: 100vh;
  background-color: #f9fafb;
}

/* Banner */
.contact-banner {
  height: 300px;
  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #fff;
}
.banner-content h1 { font-size: 2.5rem; margin-bottom: 15px; letter-spacing: 2px; }
.banner-content p { font-size: 1.1rem; opacity: 0.8; font-weight: 300; }

/* 内容区 */
.contact-content {
  max-width: 1200px;
  margin: -60px auto 0;
  padding: 0 20px 60px;
  position: relative;
  z-index: 2;
}

/* 卡片样式 */
.contact-card {
  background: #fff;
  border-radius: 16px;
  padding: 40px 20px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0,0,0,0.08);
  transition: transform 0.3s ease;
  margin-bottom: 20px;
  border: 1px solid #f0f0f0;
  height: 100%; /* 保持卡片高度一致 */
}
.contact-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(64, 158, 255, 0.15);
}

/* 图标 */
.icon-wrapper {
  width: 70px; height: 70px; margin: 0 auto 20px;
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-size: 32px;
}
.color-blue { background: #ecf5ff; color: #409EFF; }
.color-orange { background: #fdf6ec; color: #E6A23C; }
.color-green { background: #f0f9eb; color: #67C23A; }

.contact-card h3 { font-size: 1.4rem; color: #2c3e50; margin-bottom: 10px; }
.desc { color: #909399; font-size: 0.9rem; margin-bottom: 20px; }
.info-text { color: #606266; font-size: 1.1rem; font-weight: 600; margin-bottom: 5px; }

/* 二维码区域 */
.qr-section {
  margin-top: 50px;
  display: flex;
  justify-content: center;
  gap: 80px; /* 增加间距 */
  padding: 50px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.05);
}
.qr-box { text-align: center; }

/* 二维码图片容器 */
.qr-image-wrapper {
  width: 160px;
  height: 160px;
  background: #fff;
  border: 1px solid #ebeef5;
  padding: 10px; /* 留白边框 */
  border-radius: 8px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
}

.qr-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.qr-box p {
  color: #606266;
  font-weight: 600;
  margin-top: 5px;
}

.back-home-wrapper { text-align: center; margin-top: 40px; }

@media (max-width: 768px) {
  .qr-section { flex-direction: column; align-items: center; gap: 40px; }
}
</style>